import { Injectable } from '@angular/core';
import { ParameterTypeEnum } from '../enums/parameterType.enum';
import { UserPreferences } from '../models/userPreferences.model';
import { STATIC_PARAMETER_UNITS, VOLUME_UNIT } from '../shared/constants/parameterUnits.constants';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ParameterUnitService {
  constructor(protected authService: AuthService) { }

  get preferences(): UserPreferences {
    const currentUser = this.authService.getCurrentUser();
    return currentUser.preferences;
  }

  getParameterUnit(parameterType: ParameterTypeEnum): string {
    return this.preferences?.unitSymbols?.[parameterType] ?? STATIC_PARAMETER_UNITS[parameterType] ?? '';
  }

  getVolumeUnit(): string {
    return VOLUME_UNIT;
  }
}
